<template>
  <v-card>
    <v-form ref="form" :lazy-validation="true">
      <v-card-title>Ansökan om uppehåll</v-card-title>
      <v-card-actions>
        <v-icon class="close" @click="close(false)">$sl-close</v-icon>
      </v-card-actions>

      <v-card-text class="">
        <v-row no-gutters>
          <v-col cols="4">
            <p class="overline">Ansökan skapad av</p>
            <p class="mt-n3" v-if="contactPerson && contactPerson.firstName">
              <router-link :to="'/people/' + contactPerson.id">
                {{ contactPerson.firstName || '' }}
                {{ contactPerson.lastName || '' }}
              </router-link>
            </p>
          </v-col>
          <v-col cols="3">
            <p class="overline">MOBILNUMMER</p>
            <p class="mt-n3" v-if="contactPerson.mobilephone">
              <a :href="`tel:${contactPerson.mobilephone}`"> {{ contactPerson.mobilephone | phoneNo }}</a>
            </p>
          </v-col>
          <v-col cols="5"
            ><p class="overline">E-POSTADRESS</p>
            <p class="mt-n3" v-if="contactPerson && contactPerson.email">
              <a :href="`mailto:${contactPerson.email}`"> {{ contactPerson.email }}</a>
            </p>
          </v-col>
          <v-col cols="4">
            <p class="overline">Ansökan gäller</p>
            <p class="mt-n3" v-if="selectedPerson">
              <router-link :to="'/people/' + selectedPerson.id">{{ selectedPerson | fullName }}</router-link>
            </p>
          </v-col>
          <v-col cols="3">
            <p class="overline">MOBILNUMMER</p>
            <p class="mt-n3" v-if="selectedPerson && selectedPerson.mobilephone">
              <a :href="`tel:${selectedPerson.mobilephone}`"> {{ selectedPerson.mobilephone }}</a>
            </p>
          </v-col>
          <v-col cols="5"
            ><p class="overline">E-POSTADRESS</p>
            <p class="mt-n3" v-if="selectedPerson && selectedPerson.email">
              <a :href="`mailto:${selectedPerson.email}`"> {{ selectedPerson.email }}</a>
            </p>
          </v-col>
          <v-col cols="4">
            <p class="overline">Ansökan gjordes</p>
            <p class="mt-n3" v-if="selectedPerson">
              {{ get(bookPauseObj, 'createdAt', new Date('1970-01-01')) | date }}
            </p>
          </v-col>

          <v-col cols="12">
            <p class="overline mt-3">BYN-REGION</p>
            <div class="d-flex" v-if="!editRegion">
              <p class="mt-n3">
                {{ bpRegion }}
              </p>
              <v-btn
                class="ml-n6 mt-n7"
                @click="editRegion = true"
                text
                :disabled="isDisabled || !canApprove || !canUpdate"
              >
                <v-icon small>$sl-edit</v-icon>
              </v-btn>

            </div>
            <div v-else class="mb-8">
              <v-select
                data-cy="select-region"
                :items="allRegions"
                outlined
                v-model="bookPauseObj.regionId"
                id="regionSelect"
                :rules="[rules.required]"
                append-icon="$sl-arrow-down"
              ></v-select>
              <p class="mt-n4">
                När du ändrar BYN-region flyttas ansökan omgående till den valda regionen. Det kan innebära att ansökan inte längre syns för dig på sidor i Registret som listar dispensansökningar.
              </p>
              <v-btn outlined @click="changeRegion"><v-icon>$sl-double-arrow-right</v-icon>FLYTTA TILL VALD BYN-REGION</v-btn>
            </div>
          </v-col>


          <v-col cols="12" v-if="editStartDate == false"
            ><p class="overline">Startdatum (från och med)</p>
            <div class="d-flex">
              <p class="mt-n3" v-if="bookPauseObj && bookPauseObj.startDate">
                {{ bookPauseObj.startDate | date }}
              </p>
              <v-btn class="ml-n6 mt-n7" @click="editStartDate = true" text :disabled="isDisabled || !canUpdate">
                <v-icon small>$sl-edit</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="12" v-else
            ><DatePicker
              v-model="bookPauseObj.startDate"
              ref="datePicker"
              :icon="'$sl-calendar-date'"
              :label="'Startdatum'"
              :width="'250'"
              outlined
            />
          </v-col>

          <v-col cols="12" v-if="editEndDate == false"
            ><p class="mt-3 overline">Slutdatum (till och med)</p>
            <div class="d-flex">
              <p class="mt-n3" v-if="bookPauseObj && bookPauseObj.endDate">
                {{ bookPauseObj.endDate | date }}
              </p>
              <v-btn class="ml-n6 mt-n7" @click="editEndDate = true" text :disabled="isDisabled || !canUpdate">
                <v-icon small>$sl-edit</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="12" v-else
            ><DatePicker
              v-model="bookPauseObj.endDate"
              ref="datePicker"
              :icon="'$sl-calendar-date'"
              :label="'Slutdatum'"
              :width="'250'"
              outlined
            />
          </v-col>
          <v-col cols="12" v-if="editReason == false"
            ><p class="overline mt-3">Motivering</p>
            <div class="d-flex">
              <p class="mt-n3" v-if="bookPauseObj && bookPauseObj.endDate">
                {{ bookPauseObj.reason }}
              </p>
              <v-btn class="ml-n6 mt-n7" @click="editReason = true" text :disabled="isDisabled || !canUpdate">
                <v-icon small>$sl-edit</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="6" v-else
            ><v-textarea
              outlined
              rows="4"
              v-model="bookPauseObj.reason"
              :rules="[rules.required]"
              label="Motivering"
            ></v-textarea>
          </v-col>
          <v-col cols="6"></v-col>
        </v-row>

        <!-- Couraes -->
      </v-card-text>
      <v-card-text class="mt-n3" v-if="bookPauseObj.documents">
        <div class="overline">Bilagor</div>
        <div v-for="(doc, i) in bookPauseObj.documents" :key="i" class="">
          <!-- <v-icon class="mt-n2" :color="getDocumentIcon(doc.name) == 'pdf' ? 'red' : 'black'">{{
              getDocumentIcon(doc.name)
            }}</v-icon> -->

          <a @click="getDocument(doc)">{{ doc.name }}</a>
          <!-- getDocumentName(doc.contentType, doc.name, i + 1) -->
        </div>
      </v-card-text>
      <v-card-text>
        <v-row>
          <v-col cols="6"
            ><p class="overline mt-3">Godkänd av (1)</p>
            <p class="mt-n3" v-if="bookPauseObj && bookPauseObj.approvedBy">
              {{ bookPauseObj.approvedBy | fullName }}
              <span v-if="bookPauseObj.approvedAt">({{ bookPauseObj.approvedAt | date }})</span>
            </p>
            <p class="mt-n3 grey-text font-italic" v-else>Ej godkänd.</p>
          </v-col>
          <v-col cols="6"
            ><p class="overline mt-3">Godkänd av (2)</p>
            <p class="mt-n3" v-if="bookPauseObj && bookPauseObj.approvedBySecondary">
              {{ bookPauseObj.approvedBySecondary | fullName }}
              <span v-if="bookPauseObj.approvedAtSecondary">({{ bookPauseObj.approvedAtSecondary | date }})</span>
            </p>
            <p class="mt-n3 grey-text font-italic" v-else>Ej godkänd.</p>
          </v-col>
        </v-row>

        <v-row v-if="get(bookPauseObj, 'markedAsRead', null)">
          <v-col cols="6">
            <p class="overline mt-3">Hanterat av</p>
            <p class="mt-n3">
              {{ get(bookPauseObj, 'markedReadBy', null) | fullName }}
              <span v-if="bookPauseObj.markedReadAt">({{ bookPauseObj.markedReadAt | date }})</span>
            </p>
          </v-col>
        </v-row>

      </v-card-text>
      <v-card-actions class="justify-end mt-2">
        <v-btn v-if="canUndoApprove" 
          @click="undoApprove()"><v-icon>$sl-cancel</v-icon>Ångra
        </v-btn>
        <v-btn color="secondary" @click="close(false)"> <v-icon>$sl-cancel</v-icon>Avbryt </v-btn>
        <v-btn outlined @click="deleteBookPause()" :disabled="isButtonsDisabled || !canDelete">
          <v-icon>$sl-delete</v-icon>Radera
        </v-btn>
        <v-btn @click="deny()" color="secondary" :disabled="isButtonsDisabled || isEditMode || !canUpdate">
          <v-icon>$sl-dislike</v-icon>Neka
        </v-btn>
        <v-btn @click="update()" v-if="isEditMode == true" :disabled="editRegion || !canUpdate"> <v-icon>$sl-check</v-icon>Spara och Godkänn</v-btn>
        <v-btn @click="approve()" :disabled="isButtonsDisabled || !canUpdate" v-else> <v-icon>$sl-check</v-icon>Godkänn</v-btn>
      </v-card-actions>
      <p v-if="isSameUserApproved" class="info-text mt-4 pr-10">
        <i
          ><b>Obs:</b> Du har godkänt den här anmälan. Det krävs att en annan regionär kontragodkänner för att anmälan
          ska godkännas fullständigt.</i
        >
      </p>
    </v-form>
  </v-card>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {pageSize} from '@/store/constants'
import API from '@/services/api.js'
import findIndex from 'lodash/findIndex'
import sortBy from 'lodash/sortBy'
import fileDownload from 'js-file-download'
import {Regions, RulesMixin, UserRules, CanIDo} from '@/components/mixins'
import DatePicker from '@/components/common/DatePicker'
import get from 'lodash/get'

// @group Education
// PersonCasesPauseModal component
export default {
  name: 'PersonCasesPauseModal',

  mixins: [Regions, RulesMixin, UserRules, CanIDo],

  components: {
    DatePicker
  },
  props: {
    // approve/create
    mode: {
      type: String,
      default: ''
    },
    // default title
    title: {
      type: String,
      default: 'UTFÄRDA GU-INTYG'
    },
    // Person object with a default value
    bookPauseObj: {
      type: Object,
      // Object or array defaults must be returned from
      // default empty
      default: function () {
        return {}
      }
    }
  },
  data: () => ({
    contactPerson: {},
    isDisabled: false,
    editStartDate: false,
    editEndDate: false,
    editReason: false,
    editRegion: false,
    oldRegionId: null,
    oldReason: '',
    oldStartDate: '',
    oldEndDate: ''
  }),
  watch: {
    bookPauseObj() {
      this.init()
    }
  },
  computed: {
    ...mapGetters('app', ['isLoading']),
    ...mapGetters('currentuser', ['currentUser']),
    ...mapGetters('person', ['selectedPerson']),
    ...mapGetters("basic", ["basicRegions", "getRegionById"]),

    allRegions() {
      return this.basicRegions.map(r => {return {text: r.name, value: r.id}})
    },

    bpRegion() {
      const r = this.getRegionById(this.bookPauseObj.regionId)
      return r ? r.name : '' 
    },

    canUndoApprove(){
      return this.bookPauseObj && this.bookPauseObj.approvedById && this.bookPauseObj.approvedById === this.currentUser.id && !this.bookPauseObj.approvedBySecondaryId;
    },

    // // @vuese
    // //- Used to return if the currentUser's is regionary and check if it is the same regionary approved the application
    canApprove() {      
      let regionId = -1
      const bookPause = get(this, 'bookPauseObj', null)
      const educationId = get(bookPause, 'educationId', null)
      const bookId = get(bookPause, 'bookId', null)

      if( bookPause?.pauseType === 'qualificationTimePause' && educationId > 0 ) {

        //- If regionId is defined in bookPause, we use this value instead
        if ( bookPause?.regionId ) {
          regionId = bookPause.regionId
        } else {
          const found = findIndex(this.selectedPerson.educations, o => {
            return o.id === this.bookPauseObj.educationId
          })
  
          if (found >= 0) {
            if (this.selectedPerson.educations[found].regionId) {
              regionId = this.selectedPerson.educations[found].regionId
            }
          }
        }
      }

     if( bookId > 0 ) {
        //- If regionId is defined in bookPause, we use this value instead
        if ( bookPause?.regionId ) {
          regionId = bookPause?.regionId
        } else {
          const found = findIndex(this.selectedPerson.books, o => {
            return o.id === this.bookPauseObj.bookId
          })

          if (found >= 0) {
            if (this.selectedPerson.books[found].regionId) {
              regionId = this.selectedPerson.books[found].regionId
            }
          }
        }
      }

      return this.canUserApprove(regionId, this.bookPauseObj.approvedById)
    },
    isEditMode() {
      if (this.editStartDate == true || this.editEndDate == true || this.editReason == true || this.editRegion == true) return true
      else return false
    },
    isButtonsDisabled() {
      if (
        !this.canApprove ||
        this.bookPauseObj.approved == true ||
        (this.bookPauseObj.rejectedById && this.bookPauseObj.rejectedById > 0) ||
        this.editRegion
      ) {
        return true
      }
      return false
    },
    isSameUserApproved() {
      if (this.bookPauseObj.approvedBySecondaryId && this.bookPauseObj.approvedBySecondaryId > 0) {
        return false
      } else if (this.bookPauseObj && this.bookPauseObj.approvedById && this.bookPauseObj.approvedById > 0) {
        if (this.currentUser && this.currentUser.id == this.bookPauseObj.approvedById) {
          return true
        }
      }
      return false
    }
  },

  asyncComputed: {
    canUpdate(){
      return this.canIDo('book-pause', 'update');
    },
    canDelete(){
      return this.canIDo('book-pause', 'delete');
    },
  },

  created() {
    this.init()
  },
  methods: {
    ...mapActions('person', ['updateSelectedPerson', 'setSelectedPerson']),

    sortBy: sortBy,

    get,

    init() {
      this.oldRegionId = this.bookPauseObj.regionId
      this.oldReason = this.bookPauseObj.reason
      this.oldStartDate = this.bookPauseObj.startDate
      this.oldEndDate = this.bookPauseObj.endDate
      if (
        this.bookPauseObj.approved == true ||
        this.canApprove == false ||
        (this.bookPauseObj.rejectedById && this.bookPauseObj.rejectedById > 0)
      ) {
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
      this.editStartDate = false
      this.editEndDate = false
      this.editReason = false
      this.editRegion = false

      if (this.bookPauseObj.createdBy && this.bookPauseObj.createdBy.id) this.getPerson(this.bookPauseObj.createdBy.id)
    },
    getDocumentName(alias, fileName, id) {
      var type = fileName.split('.')
      if (type.length == 2) {
        return alias + '(' + id + ').' + type[1]
      }
      return ''
    },
    getDocumentIcon(e) {
      var type = ''
      var icon = 'mdi-file-pdf-outline'
      type = e.split('.')
      if (type[type.length - 1].toUpperCase() == 'pdf') {
        icon = 'mdi-file-pdf-outline'
      } else {
        icon = 'mdi-file-document-outline'
      }

      return icon
    },
    getDocument(doc) {
      API.getDocuments(doc.id)
        .then(response => {
          fileDownload(response.data, doc.name, response.headers['content-type'])
        })
        .catch(error => {
          console.log('get document error, ' + doc, error)
        })
    },

    undoApprove(){
       API.undoApprovePauseBook(this.bookPauseObj.id).then(() => {
          this.bookPauseObj.approvedBy = null;
          this.bookPauseObj.approvedById = null;
          this.bookPauseObj.approvedAt = null;
          this.isDisabled = false;
          this.updateSelectedPerson()
       })
        .catch(error => {
          console.log('There was an error:', error)
          this.$events.fire('showError', 'Det gick tyvärr inte att spara dina ändringar! Detta är ett ovanligt fel och om det händer igen v.v. kontakta BYN:s kansli.')
        })
    },

    //needs to be approve by 2 persons. Check first if it is approved by a first person.
    approve() {
      API.approvePauseBook(this.bookPauseObj.id)
        .then(res => {
          if (this.bookPauseObj.approvedById && this.bookPauseObj.approvedById > 0) {
            this.bookPauseObj.approvedBySecondary = {
              firstName: this.currentUser.firstName,
              lastName: this.currentUser.lastName
            }
            this.bookPauseObj.approvedBySecondaryId = this.currentUser.id
            this.bookPauseObj.approvedAtSecondary = new Date()
            this.bookPauseObj.approved = true
            this.isDisabled = true
            this.updateSelectedPerson()                    
          } else {
            this.bookPauseObj.approvedBy = {firstName: this.currentUser.firstName, lastName: this.currentUser.lastName}
            this.bookPauseObj.approvedById = this.currentUser.id
            this.bookPauseObj.approvedAt = new Date()
            this.isDisabled = true          
            this.updateSelectedPerson()                    
          }
        })
        .catch(error => {
          console.log('There was an error:', error)
          this.$events.fire('showError', 'Det gick tyvärr inte att spara dina ändringar! Detta är ett ovanligt fel och om det händer igen v.v. kontakta BYN:s kansli.')
        })

      // this.bookPauseObj.reason = this.oldReason
      // this.bookPauseObj.endDate = this.oldEndDate
      // this.bookPauseObj.startDate = this.oldStartDate
      // this.editStartDate = false
      // this.editEndDate = false
      // this.editReason = false
      //this.$emit('close', true)
    },

    //reset the form and close emit to close the modal
    close(updated) {
      //reset the form with the original value
      this.bookPauseObj.regionId = this.oldRegionId
      this.bookPauseObj.reason = this.oldReason
      this.bookPauseObj.endDate = this.oldEndDate
      this.bookPauseObj.startDate = this.oldStartDate

      this.editStartDate = false
      this.editEndDate = false
      this.editReason = false      
      this.$emit('close', updated)
    },

    async deny() {
      const res = await this.$dialog.confirm({
        text: 'Detta går inte att ångra.',
        title: 'Vill du neka denna ansökan?',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Neka', key: true, icon: '$sl-dislike', outlined: true}
        ]
      })
      if (res !== true) return                

      API.denyPauseBook(this.bookPauseObj.id)
        .then(res => { 
          this.$events.fire('showInfo', 'Ansökan nekad.')
          this.bookPauseObj.rejectedById = this.currentUser.id
          this.bookPauseObj.rejectedAt = new Date()
          this.isDisabled = true          
          
          this.bookPauseObj.approvedBy = null
          this.bookPauseObj.approvedById = null
          this.bookPauseObj.approvedAt = null          
          this.updateSelectedPerson()        
          //this.close(true)
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    },
    updateSelectedPerson(){ 
      let found = -1
      let foundPauses = {}
      if(this.selectedPerson && this.selectedPerson.educations && this.selectedPerson.educations.length>0 && this.bookPauseObj.pauseType=="qualificationTimePause" && this.bookPauseObj.educationId && this.bookPauseObj.educationId>0) {              
        found = findIndex(this.selectedPerson.educations, o => {
          return o.id === this.bookPauseObj.educationId
        })        
        foundPauses = findIndex(this.selectedPerson.educations[found].qualificationTimePauses, f => {
          return f.id === this.bookPauseObj.id
        })
        if(foundPauses > -1)
          this.selectedPerson.educations[found].qualificationTimePauses[foundPauses] = this.bookPauseObj
      }
      else {
        found = findIndex(this.selectedPerson.books, o => {
          return o.id === this.bookPauseObj.bookId
        })
        foundPauses = findIndex(this.selectedPerson.books[found].bookPauses, f => {
          return f.id === this.bookPauseObj.id
        })
        if(foundPauses > -1)
        this.selectedPerson.books[found].bookPauses[foundPauses] = this.bookPauseObj
      }

      if(foundPauses > -1){
        this.setSelectedPerson(this.selectedPerson)        
        this.close(true)
      }
    },

    changeRegion() {
      if (this.oldRegionId !== this.bookPauseObj.regionId) {
        this.update(false)
      }
    },

    //update the form and remove all approvements. After saved, needs to be approved by 2 different persons.
    update(doApprove=true) {
      if (!this.$refs.form.validate() || !(this.bookPauseObj && this.bookPauseObj.id)) {
        return this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
      }

      if (
        this.bookPauseObj.startDate != this.oldStartDate ||
        this.bookPauseObj.endDate != this.oldEndDate ||
        this.bookPauseObj.reason != this.oldReason ||
        this.bookPauseObj.regionId != this.oldRegionId
      ) {
        this.bookPauseObj.approvedBy = null
        this.bookPauseObj.approvedById = null
        this.bookPauseObj.approvedAt = null

        API.updatePauseBook(this.bookPauseObj.id, {data: this.bookPauseObj})
          .then(res => {
            this.editStartDate = false
            this.editEndDate = false
            this.editReason = false           
           // if (found >= 0 && foundPauses >= 0) {                                            
              //this.setSelectedPerson(this.selectedPerson)
              this.oldReason = this.bookPauseObj.reason
              this.oldStartDate = this.bookPauseObj.startDate
              this.oldEndDate = this.bookPauseObj.endDate
              this.oldRegionId = this.bookPauseObj.regionId
              
            if(doApprove==true)
                this.approve()
            else{
              this.updateSelectedPerson()
              this.$events.fire('showInfo', 'Updaterad.')
            }
            //}
           // this.$emit('close', true)
            
          })
          .catch(error => {
            console.log('There was an error:', error)
          })
      } else {
        this.close(false)
      }
    },
    async deleteBookPause() {
      const res = await this.$dialog.confirm({
        text: 'Radering av ansökan går inte att ångra.',
        title: 'Vill du verkligen radera denna ansökan?',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true, icon: '$sl-delete', outlined: true}
        ]
      })
      if (res !== true) return

      const found = findIndex(this.selectedPerson.books, o => {
        return o.id === this.bookPauseObj.bookId
      })

      API.deletePauseBook(this.bookPauseObj.id)
        .then(res => {
          this.$events.fire('showInfo', 'Ansökan raderad.')
          if (found >= 0) {
            const foundPauses = findIndex(this.selectedPerson.books[found].bookPauses, f => {
              return f.id === this.bookPauseObj.id
            })
            if (foundPauses >= 0) {
              this.selectedPerson.books[found].bookPauses.splice(foundPauses, 1)
            }
          }
          this.$emit('close', true)
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    },
    getPerson(id) {
      API.getPerson(id)
        .then(res => {
          this.contactPerson = res.data
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    }
  }
}
</script>
